module.exports = __webpack_public_path__ + "img/logo.8fe30531.png";